<template>
  <div class="reception-status">
    <RingIcon v-if="status === 1" class="available" />
    <template v-else-if="[2, 4].includes(status)">
      <CloseIcon v-if="notAvailableType === 1 || !isJa" />
      <div v-else class="over">
        <p class="only-pc">TEL</p>
        <a :href="`tel:${tel}`" class="only-sp" @click="onTel">TEL</a>
      </div>
    </template>
    <CloseIcon v-else-if="status === 3" />
    <template v-else-if="status === 5">
      <div v-if="isJa" class="holiday">休</div>
      <CloseIcon v-else />
    </template>
    <div v-else class="none">-</div>
  </div>
</template>

<script>
import CloseIcon from '@/components/icons/close'
import RingIcon from '@/components/icons/ring'

/**
 * 受付ステータス
 */
export default {
  name: 'ReceptionStatus',
  components: {
    CloseIcon,
    RingIcon,
  },
  props: {
    /** ステータス */
    status: { type: Number, default: null },
    /** 予約不可表示 */
    notAvailableType: { type: Number, default: null },
    /** 店舗電話番号 */
    tel: { type: String, default: null },
  },
  computed: {
    isJa() {
      return this.$i18n.locale === 'ja'
    },
  },
  methods: {
    onTel() {
      /**
       * TELのクリック
       * @event click
       * @type {string}
       */
      this.$emit('tel')
    },
  },
}
</script>

<style lang="postcss" scoped>
.reception-status {
  align-items: center;
  display: flex;
  height: 24px;
  white-space: nowrap;
}

.none {
  font-size: 12px;
}

.available {
  fill: var(--brand-color);
  height: 20px;
  width: 20px;
}

.only-pc {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
}

.only-sp {
  @media screen and (min-width: 768px) {
    display: none;
  }
}
</style>
